import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { ShieldAlert, X } from "lucide-react";
import { Button } from "./Button";
import styles from "./TrialExpiredDialog.module.css";

export function TrialExpiredDialog() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("trial-expired", handler);
    return () => window.removeEventListener("trial-expired", handler);
  }, []);

  const handleUpgrade = () => {
    setOpen(false);
    navigate("/settings");
  };

  return (
    <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className={styles.overlay} />
        <DialogPrimitive.Content className={styles.content}>
          <DialogPrimitive.Close className={styles.closeBtn}>
            <X size={20} />
            <span className="sr-only">Close</span>
          </DialogPrimitive.Close>
          
          <div className={styles.iconContainer}>
            <ShieldAlert className={styles.icon} />
            <div className={styles.iconGlow} />
          </div>
          
          <DialogPrimitive.Title className={styles.title}>
            Free Trial Expired
          </DialogPrimitive.Title>
          
          <DialogPrimitive.Description className={styles.description}>
            Your free trial has ended. Upgrade to the Pro plan to continue using all features of BhadaPMS.
          </DialogPrimitive.Description>
          
          <div className={styles.actions}>
            <Button 
              className={styles.upgradeBtn}
              onClick={handleUpgrade}
            >
              Upgrade to Pro — ₹2,000/mo
            </Button>
            <p className={styles.secondaryNote}>
              You'll be redirected to the subscription page to complete your upgrade.
            </p>
          </div>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}